import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const CopGridPage = lazy(() => import('@/pages/cop'));

export const copRoutes: RouteConfig = {
  path: '/cop',
  layout: DashboardLayout,
  element: CopGridPage,
};
